import * as msal from "@azure/msal-browser";
import { default as LogHandler, LogType } from "@/helpers/utilities/Handlers/LogHandler";

let msalInstance;
let account;

const msalConfig = {
  auth: {},
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            LogHandler.log(LogType.ERROR, "msalConnection", message);
            return;
          case msal.LogLevel.Info:
            return;
          case msal.LogLevel.Verbose:
            return;
          case msal.LogLevel.Warning:
            return;
        }
      }
    }
  }
};

export default {
  get msalInstance() {
    return msalInstance;
  },

  get msalAccount() {
    return account;
  },

  async init(tennantId, graphClientId) {
    if (graphClientId != null) {
      msalConfig.auth.clientId = graphClientId;
      msalConfig.auth.authority = `https://login.microsoftonline.com/${tennantId}`;
      msalConfig.auth.redirectUri = window.location.protocol + "//" + window.location.host;
      msalInstance = new msal.PublicClientApplication(msalConfig);

      // Register Callbacks for Redirect flow
      await msalInstance
        .handleRedirectPromise()
        .then(async res => {
          await this.handleResponse(res);
        })
        .catch(error => {
          LogHandler.log(LogType.ERROR, "msalConnection", error);
        });
    }
  },

  async handleResponse(resp) {
    if (resp !== null) {
      account = resp.account;
    } else {
      const currentAccounts = msalInstance.getAllAccounts();
      if (!currentAccounts || currentAccounts.length < 1) {
        await this.signIn();
      } else {
        account = currentAccounts[0];
      }
    }
  },

  signIn() {
    if (msalInstance === undefined) {
      LogHandler.log(LogType.ERROR, "msalConnection", "MSAL not initialized");
      return;
    }
    return msalInstance.loginRedirect();
  },

  signOut() {
    const logoutRequest = {
      account: account
    };
    account = null;
    if (msalInstance) {
      msalInstance.logoutRedirect(logoutRequest);
    }
  }
};
